import { render } from "./SettingsModal.vue?vue&type=template&id=03a8b2ac"
import script from "./SettingsModal.vue?vue&type=script&lang=js"
export * from "./SettingsModal.vue?vue&type=script&lang=js"

import "./SettingsModal.vue?vue&type=style&index=0&id=03a8b2ac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__